import type { useEntryPoint } from './use-entry-point';
import type { EntryPointActions } from './utils/types';

export const mockEntryPointActions: EntryPointActions = {
	cancelPreload() {},
	load() {},
	preload() {},
	unload() {},
};

export const mockUseEntryPointResult: ReturnType<typeof useEntryPoint> = {
	entryPointActions: mockEntryPointActions,
	entryPointReferenceSubject: {
		getValue: () => null,
		subscribe: () => () => {},
	},
	stopMetric() {},
};
